module.exports = __webpack_public_path__ + "img/icon-wfh.6cc536ea.png";